import { create } from "zustand";

export type VideoType = "SALES" | "ORGANIC" | null;

export interface productInfo {
  id: string;
  name: string;
}

export interface funnelInfo {
  id: string;
  brand_name: string;
}

export interface Narrative {
  id: string;
  created_at: string;
  updated_at: string;
  owner_id: string;
  product_information?: productInfo;
  website_information?: funnelInfo;
  sale_angle?: string;
  narrative_name: string;
  style: string | null;
  video_type: VideoType;
  content_narrative: string;
  is_recorded: boolean;
}

interface AdsPageState {
  narratives: Narrative[];
  setNarratives: (narratives: Narrative[]) => void;
  filteredNarratives: Narrative[];
  setFilteredNarratives: (narratives: Narrative[]) => void;
  selectedVideoType: VideoType;
  selectedStyles: string[];
  setSelectedVideoType: (videoType: VideoType) => void;
  setSelectedStyles: (styles: string[]) => void;
  selectedNarrative: Narrative | null;
  setSelectedNarrative: (narrative: Narrative | null) => void;
}

const useAdsPageStore = create<AdsPageState>((set) => ({
  narratives: [],
  setNarratives: (narratives) => set({ narratives }),
  filteredNarratives: [],
  setFilteredNarratives: (narratives) => set({ filteredNarratives: narratives }),
  selectedVideoType: "SALES",
  selectedStyles: [],
  setSelectedVideoType: (videoType) => set({ selectedVideoType: videoType }),
  setSelectedStyles: (styles) => set({ selectedStyles: styles }),
  selectedNarrative: null,
  setSelectedNarrative: (narrative) => set({ selectedNarrative: narrative }),
}));

export default useAdsPageStore;
